import {
  setAccessTokenCookie,
  setAccountNoCookie,
  setRefreshTokenCookie
} from '~/utils'

/** 授權 */
export const useAuthStore = defineStore('auth', () => {
  /** Access Token */
  const accessToken = ref('')

  /** Refresh Token */
  const refreshToken = ref('')

  /** 使用者帳號 */
  const accountNo = ref('')

  /** 設定使用者帳號 */
  function setAccountNo(value: string) {
    accountNo.value = value
  }

  /** 設定 Access Token */
  function setAccessToken(value: string) {
    accessToken.value = value
  }

  /** 設定 Refresh Token */
  function setRefreshToken(value: string) {
    refreshToken.value = value
  }

  function setStoreAndCookies(options: {
    accessToken: string
    account: string
    refreshToken: string
  }) {
    if (import.meta.client) {
      setAccessTokenCookie(options.accessToken)
      setRefreshTokenCookie(options.refreshToken)
      setAccountNoCookie(options.account)
    }

    accessToken.value = options.accessToken
    refreshToken.value = options.refreshToken
    accountNo.value = options.account
  }

  return {
    accountNo,
    accessToken,
    refreshToken,
    setAccountNo,
    setAccessToken,
    setRefreshToken,
    setStoreAndCookies
  }
})
